import { render, staticRenderFns } from "./FileStatusBadge.vue?vue&type=template&id=a86a9482&"
import script from "./FileStatusBadge.vue?vue&type=script&lang=js&"
export * from "./FileStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports